var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMixMatchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3276",
    "data-name": "Rectangle 3276",
    width: 24,
    height: 24,
    transform: "translate(27 998)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mix_Match",
    "data-name": "Mix & Match",
    transform: "translate(-27 -998)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "application",
    transform: "translate(10.981 981.981)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10541",
    "data-name": "Path 10541",
    d: "M22.718,20h-.68A2.039,2.039,0,0,0,20,22.039V34a2.039,2.039,0,0,0,2.039,2.039H34A2.039,2.039,0,0,0,36.037,34V22.039A2.039,2.039,0,0,0,34,20H25.436v1.359A1.359,1.359,0,0,0,26.8,22.718h9.242",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_448",
    "data-name": "Ellipse 448",
    cx: 1.359,
    cy: 1.359,
    r: 1.359,
    transform: "translate(23.378 26.66) rotate(-45)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_449",
    "data-name": "Ellipse 449",
    cx: 1.359,
    cy: 1.359,
    r: 1.359,
    transform: "translate(28.815 26.66) rotate(-45)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_450",
    "data-name": "Ellipse 450",
    cx: 1.359,
    cy: 1.359,
    r: 1.359,
    transform: "translate(28.815 32.096) rotate(-45)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_451",
    "data-name": "Ellipse 451",
    cx: 1.359,
    cy: 1.359,
    r: 1.359,
    transform: "translate(23.378 32.096) rotate(-45)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixMatchIcon);
export default __webpack_public_path__ + "static/media/mix-match-icon.9c1be644682921dcbafd1240e3c8f327.svg";
export { ForwardRef as ReactComponent };